/* eslint-disable import/no-default-export */
export default () => [
  { id: 0, description: 'Now' },
  { id: 2, description: '2 weeks' },
  { id: 4, description: '4 weeks' },
  { id: 8, description: '8 weeks' },
  { id: 12, description: '12+ weeks' },
];
